// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DividerTokens } from './type';

const dividerTokens: DividerTokens = {
  dividerFontSize: 'Font-12',
  dividerFontColor: 'Neutral-text-5',
  dividerFontWeight: 'Weight-regular',
  dividerBorderColor: 'Neutral-border-1',
  dividerBorderWidth: 'Border-1',
  dividerHorizontalMarginY: 'Spacing-24',
  dividerHorizontalTextMarginY: 'Spacing-16',
  dividerVerticalMarginX: 'Spacing-12',
  dividerTextPaddingX: 'Spacing-12',
};

export default dividerTokens;
